// extracted by mini-css-extract-plugin
export default {"root":"p0vHEEhItF","root_large":"ucR6lCzYSf","label":"RuIyORWFgZ","button":"tI9Opo9gtp","content":"e8Mcf6zjaR"};